// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-table .ant-table-thead > tr > th {
  background-color: #005cff !important;
  color: white !important;
  font-weight: bold;
  text-align: center;
  /* border: 0.5px solid #ddd !important; */
}

.custom-table .ant-table-tbody > tr > td {
  border: 0.5px solid #ddd !important;
}

/* .custom-table {
    border: 0.5px solid #ddd !important;
    border-radius: 5px;
  } */

.clickable-row {
  cursor: pointer;
  transition: background-color 0.2s;
}

.clickable-row:hover {
  background-color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/components/TableView.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;KAGK;;AAEL;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".custom-table .ant-table-thead > tr > th {\n  background-color: #005cff !important;\n  color: white !important;\n  font-weight: bold;\n  text-align: center;\n  /* border: 0.5px solid #ddd !important; */\n}\n\n.custom-table .ant-table-tbody > tr > td {\n  border: 0.5px solid #ddd !important;\n}\n\n/* .custom-table {\n    border: 0.5px solid #ddd !important;\n    border-radius: 5px;\n  } */\n\n.clickable-row {\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.clickable-row:hover {\n  background-color: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
